module.exports = __webpack_public_path__ + "bc86cacb2396451bff66be931f9fee11.svg";